var CHAR_SET = ['nnwwn', 'wnnnw', 'nwnnw', 'wwnnn', 'nnwnw', 'wnwnn', 'nwwnn', 'nnnww', 'wnnwn', 'nwnwn'];

module.exports = function (lines) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'standard';
  var code = [];
  var barThreshold = Math.ceil(lines.reduce(function (pre, item) {
    return (pre + item) / 2;
  }, 0));

  if (type === 'interleaved') {
    // extract start/ends pair
    var startChar = lines.splice(0, 4).map(function (line) {
      return line > barThreshold ? 'w' : 'n';
    }).join('');
    var endChar = lines.splice(lines.length - 3, 3).map(function (line) {
      return line > barThreshold ? 'w' : 'n';
    }).join('');
    if (startChar !== 'nnnn' || endChar !== 'wnn') return null; // Read one encoded character at a time.

    while (lines.length > 0) {
      var seg = lines.splice(0, 10);
      var a = seg.filter(function (item, index) {
        return index % 2 === 0;
      }).map(function (line) {
        return line > barThreshold ? 'w' : 'n';
      }).join('');
      code.push(CHAR_SET.indexOf(a));
      var b = seg.filter(function (item, index) {
        return index % 2 !== 0;
      }).map(function (line) {
        return line > barThreshold ? 'w' : 'n';
      }).join('');
      code.push(CHAR_SET.indexOf(b));
    }
  } else if (type === 'standard') {
    // extract start/ends pair
    var _startChar = lines.splice(0, 6).filter(function (item, index) {
      return index % 2 === 0;
    }).map(function (line) {
      return line > barThreshold ? 'w' : 'n';
    }).join('');

    var _endChar = lines.splice(lines.length - 5, 5).filter(function (item, index) {
      return index % 2 === 0;
    }).map(function (line) {
      return line > barThreshold ? 'w' : 'n';
    }).join('');

    if (_startChar !== 'wwn' || _endChar !== 'wnw') return null; // Read one encoded character at a time.

    while (lines.length > 0) {
      var _a = lines.splice(0, 10).filter(function (item, index) {
        return index % 2 === 0;
      }).map(function (line) {
        return line > barThreshold ? 'w' : 'n';
      }).join('');

      code.push(CHAR_SET.indexOf(_a));
    }
  }

  return code.join('');
};